import React from "react";
import Table from "react-bootstrap/Table";
import moment from "moment";
import "./DetaljiTable.css";
import { PaperClipOutlined, ZoomInOutlined } from "@ant-design/icons";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import RazlogBrisanjaComponent from "./RazlogBrisanjaComponent";

const OvlasteniRevizoriDrugihDrzavaDetaljiTable = (props) => {
  let osoba;
  let adresaOsobe = [];
  let registracijaOsobe = [];
  let osobaDrustvo = [];
  let dokumentOsobe = [];
  let mjere = [];

  let adresaPrebivalista = [];
  let adresaBoravista = [];
  let povezanaDrustva = [];
  let samostalniRevizori = [];

  let odobrenjeZaRad = [];
  let odobrenjeZaRadMatDrzava = [];
  let regDrugaDrzava = [];
  let nadleznaTijela = [];

  let registar = props.children;

  osoba = registar[1];
  adresaOsobe = registar[2];
  registracijaOsobe = registar[3];
  osobaDrustvo = registar[4];
  dokumentOsobe = registar[5];
  mjere = registar[7];

  adresaPrebivalista = adresaOsobe.filter((x) => x.vrAdr === 1)[0];

  adresaBoravista = adresaOsobe.filter((x) => x.vrAdr === 2)[0];

  povezanaDrustva = osobaDrustvo.filter(
    (x) => x.vrVeze == 1 && x.vrDrustva != 2
  );

  samostalniRevizori = osobaDrustvo.filter(
    (x) => x.vrVeze == 1 && x.vrDrustva == 2
  );

  odobrenjeZaRad = registracijaOsobe.filter(
    (x) => x.vrRegistracije == 1 && x.sifDrzave == 191
  );

  odobrenjeZaRadMatDrzava = registracijaOsobe.filter(
    (x) => x.vrRegistracije == 1 && x.sifDrzave != 191
  );

  regDrugaDrzava = registracijaOsobe.filter((x) => x.vrRegistracije == 2);

  nadleznaTijela = registracijaOsobe.filter((x) => x.vrRegistracije == 3);

  const noDataMessage = "";

  const { userRole } = props;
  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <div id="printArea">
      {osoba.napomena ? (
        <RazlogBrisanjaComponent razlog={osoba.napomena} />
      ) : null}
      <h5>Pregled podataka</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">
                {osoba.idBroj ? "Identifikacijski broj" : "OIB"}
              </th>
            ) : null}
            <th scope="col">Registarski broj</th>
            <th scope="col">Broj i datum odobrenja za rad u RH</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {osoba.ime} {osoba.prezime}
            </td>
            {checkIfUserIsAdmin ? (
              <td>
                {osoba.idBroj
                  ? osoba.idBroj
                  : osoba.oib
                  ? osoba.oib
                  : noDataMessage}
              </td>
            ) : null}
            <td>{osoba.regBroj}</td>
            <td className="hr-divider">
              {odobrenjeZaRad.map((element) => (
                <>
                  <table>
                    {!element.brReg && !element.datReg ? (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Izdavatelj: </b>
                            Hrvatska revizorska komora
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj odobrenja za rad: </b>
                            {element.brReg}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum odobrenja za rad: </b>
                            {element.datReg}
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  <hr />{" "}
                </>
              ))}
            </td>
          </tr>
        </tbody>
      </Table>

      {checkIfUserIsAdmin ? (
        <>
          <h5>Adrese</h5>
          <Table responsive bordered hover>
            <thead>
              <tr className="tr_table">
                <th scope="col">Adresa prebivališta</th>
                <th scope="col">Adresa boravišta</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <table>
                    <tbody>
                      {adresaOsobe.ulicaKbr ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {adresaOsobe.ulicaKbr}
                          </td>
                        </tr>
                      ) : null}
                      {adresaPrebivalista.brPoste ||
                      adresaPrebivalista.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {adresaPrebivalista.brPoste}
                            {adresaPrebivalista.nazNaselja &&
                              " " + adresaPrebivalista.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {adresaPrebivalista.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {adresaPrebivalista.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {adresaBoravista.ulicaKbr
                            ? adresaBoravista.ulicaKbr
                            : noDataMessage}
                        </td>
                      </tr>
                      {adresaBoravista.brPoste || adresaBoravista.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {adresaBoravista.brPoste}
                            {adresaBoravista.nazNaselja &&
                              " " + adresaBoravista.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {adresaBoravista.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {adresaBoravista.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </Table>
        </>
      ) : null}

      <h5>
        Revizorska društva ili samostalni revizor kod kojega je revizor zaposlen
        ili s kojim je povezan kao partner ili na drugi način
      </h5>
      <br></br>
      <h5>Revizorska društva</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Adresa</th>
            <th scope="col">Internet stranica</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {povezanaDrustva.length > 0 ? (
            povezanaDrustva.map((revDr, index) => (
              <tr key={`povezana-drustva${index}`}>
                {revDr.vrDrustva !== 2 ? (
                  <>
                    <td>
                      {revDr.nazivDrustva
                        ? revDr.nazivDrustva
                        : revDr.imeDrustva + " " + revDr.prezimeDrustva}
                    </td>
                    <td>{revDr.regBrojDrustva}</td>
                    <td>
                      <table>
                        <tbody>
                          {revDr.ulicaKbrDrustva ? (
                            <tr>
                              <td className="inner-td">
                                <b>Ulica i kbr: </b>
                                {revDr.ulicaKbrDrustva}
                              </td>
                            </tr>
                          ) : (
                            noDataMessage
                          )}
                          {revDr.postanskiBrojDrustva ||
                          revDr.nazivNaseljaDrustva ||
                          revDr.gradDrustva ? (
                            <tr>
                              <td className="inner-td">
                                <b>Grad: </b>
                                {revDr.postanskiBrojDrustva}
                                {revDr.nazivNaseljaDrustva &&
                                  " " + revDr.nazivNaseljaDrustva}
                                {revDr.gradDrustva && ", " + revDr.gradDrustva}
                              </td>
                            </tr>
                          ) : null}
                          {revDr.nazDrzaveDrustva ? (
                            <tr>
                              <td className="inner-td">
                                <b>Država: </b>
                                {revDr.nazDrzaveDrustva}
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </td>
                    <td className="focusable">
                      {revDr.web ? (
                        <a href={"http://" + revDr.web} target="_blank">
                          {revDr.web}
                        </a>
                      ) : (
                        noDataMessage
                      )}
                    </td>
                    <td className="ant_batn">
                      <ButtonComponent
                        variant="secondary"
                        onClick={(e) =>
                          props.detaljiSecondaryClicked(
                            "drustvo",
                            revDr.idDrustva,
                            revDr.vrDrustva,
                            false
                          )
                        }
                      >
                        <ZoomInOutlined />
                      </ButtonComponent>
                    </td>
                  </>
                ) : (
                  ""
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Samostalni revizori</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Adresa</th>
            <th scope="col">Internet stranica</th>
            <th scope="col">Detalji</th>
          </tr>
        </thead>
        <tbody>
          {samostalniRevizori.length > 0 ? (
            samostalniRevizori.map((rev, index) => (
              <tr key={`samostalni-revizori${index}`}>
                <td>{rev.imeDrustva + " " + rev.prezimeDrustva}</td>
                <td>{rev.regBrojDrustva}</td>
                <td>
                  <table>
                    <tbody>
                      {rev.ulicaKbrDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {rev.ulicaKbrDrustva}
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td className="inner-td"> {noDataMessage}</td>
                        </tr>
                      )}
                      {rev.postanskiBrojDrustva ||
                      rev.nazivNaseljaDrustva ||
                      rev.gradDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {rev.postanskiBrojDrustva}
                            {rev.nazivNaseljaDrustva &&
                              " " + rev.nazivNaseljaDrustva}
                            {rev.gradDrustva && ", " + rev.gradDrustva}
                          </td>
                        </tr>
                      ) : null}
                      {rev.nazDrzaveDrustva ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {rev.nazDrzaveDrustva}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td className="focusable">
                  {rev.web ? (
                    <a href={"http://" + rev.web} target="_blank">
                      {rev.web}
                    </a>
                  ) : (
                    noDataMessage
                  )}
                </td>
                <td className="ant_batn">
                  <ButtonComponent
                    variant="secondary"
                    onClick={(e) =>
                      props.detaljiSecondaryClicked(
                        "drustvo",
                        rev.idDrustva,
                        rev.vrDrustva,
                        false
                      )
                    }
                  >
                    <ZoomInOutlined />
                  </ButtonComponent>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Registracija kod nadležnog tijela matične države članice</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Registarski broj nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum odobrenja za rad</th>
          </tr>
        </thead>
        <tbody>
          {odobrenjeZaRadMatDrzava.length > 0 ? (
            odobrenjeZaRadMatDrzava.map((odobrenjeZaRad, index) =>
              !odobrenjeZaRad.nazTijela &&
              !odobrenjeZaRad.brRegOrig &&
              !odobrenjeZaRad.ulicaKbr &&
              !odobrenjeZaRad.brPoste &&
              !odobrenjeZaRad.nazNaselja &&
              !odobrenjeZaRad.brReg &&
              !odobrenjeZaRad.datReg ? (
                <tr>
                  <td colSpan="4"></td>
                </tr>
              ) : (
                <tr key={`odobrenje-mat-drzava${index}`}>
                  <td>
                    {odobrenjeZaRad.nazTijela
                      ? odobrenjeZaRad.nazTijela
                      : noDataMessage}
                  </td>
                  <td>
                    {odobrenjeZaRad.brRegOrig
                      ? odobrenjeZaRad.brRegOrig
                      : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {odobrenjeZaRad.ulicaKbr
                              ? odobrenjeZaRad.ulicaKbr
                              : noDataMessage}
                          </td>
                        </tr>
                        {odobrenjeZaRad.brPoste || odobrenjeZaRad.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {odobrenjeZaRad.brPoste}
                              {odobrenjeZaRad.nazNaselja &&
                                " " + odobrenjeZaRad.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {odobrenjeZaRad.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {odobrenjeZaRad.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj odobrenja za rad: </b>
                            {odobrenjeZaRad.brReg
                              ? odobrenjeZaRad.brReg
                              : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum odobrenja za rad: </b>
                            {odobrenjeZaRad.datReg
                              ? odobrenjeZaRad.datReg
                              : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr>
              <td colSpan="4"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Svaka druga registracija kod nadležnih tijela drugih država članica
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {regDrugaDrzava.length > 0 ? (
            regDrugaDrzava.map((reg, index) =>
              !reg.brReg &&
              !reg.datReg &&
              !reg.nazTijela &&
              !reg.ulicaKbr &&
              !reg.brPoste &&
              !reg.nazNaselja ? (
                <tr key={`reg-dr-drz${index}`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`reg-dr-drz${index}`}>
                  <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>
                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {reg.brReg ? reg.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {reg.datReg ? reg.datReg : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`reg-dr-drz`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Nadležno tijelo države članice odgovorno za nadzor osiguranja kvalitete
        rada i nadzor ovlaštenih revizora
      </h5>
      <h5> i revizorskih društava</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
          </tr>
        </thead>
        <tbody>
          {nadleznaTijela.length > 0 ? (
            nadleznaTijela.map((nadleznoTijelo, index) =>
              !nadleznoTijelo.nazTijela &&
              !nadleznoTijelo.ulicaKbr &&
              !nadleznoTijelo.brPoste &&
              !nadleznoTijelo.nazNaselja ? (
                <tr key={`nadlezna-tijela${index}`}>
                  <td colSpan="2"></td>
                </tr>
              ) : (
                <tr key={`nadlezna-tijela${index}`}>
                  <td>
                    {nadleznoTijelo.nazTijela
                      ? nadleznoTijelo.nazTijela
                      : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        {nadleznoTijelo.ulicaKbr ? (
                          <tr>
                            <td className="inner-td">
                              <b>Ulica i kbr: </b>
                              {nadleznoTijelo.ulicaKbr}
                            </td>
                          </tr>
                        ) : (
                          noDataMessage
                        )}
                        {nadleznoTijelo.brPoste || nadleznoTijelo.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {nadleznoTijelo.brPoste}
                              {nadleznoTijelo.nazNaselja &&
                                " " + nadleznoTijelo.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {nadleznoTijelo.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {nadleznoTijelo.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`nadlezna-tijela`}>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Izrečene odluke i nadzorne mjere</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Vrsta mjere</th>
            <th scope="col">Rješenje</th>
            <th scope="col">Broj i datum rješenja</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">Datum dostave rješenja subjektu</th>
            ) : (
              ""
            )}
            {/* <th scope="col">Napomena</th> */}
            <th scope="col">Upravni spor</th>
            <th scope="col">Datum pravomoćnosti</th>
            <th scope="col">Prekršajni postupak</th>
            {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
              <th scope="col">Datum brisanja</th>
            ) : (
              ""
            )}
          </tr>
        </thead>
        <tbody>
          {mjere.length ? (
            mjere.map((mjera, index) => (
              <tr key={`mjere${index}`}>
                <td>{mjera.vrstaMjere ? mjera.vrstaMjere : noDataMessage}</td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentOsoba(e, mjera.idMjereOsobe)
                    }
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Broj rješenja: </b>
                          {mjera.brRjesenja ? mjera.brRjesenja : noDataMessage}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Datum rješenja: </b>
                          {mjera.datRjesenja
                            ? mjera.datRjesenja
                            : noDataMessage}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datPreuzimanja
                      ? mjera.datPreuzimanja
                      : noDataMessage}
                  </td>
                ) : null}
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentUSOsoba(e, mjera.idMjereOsobe)
                    }
                    disabled={mjera.nazivDok2 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>

                  <table>
                    <tbody>
                      {mjera.napomena2 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena2}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  {mjera.datPravomocnosti
                    ? mjera.datPravomocnosti
                    : noDataMessage}
                </td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentPPOsoba(e, mjera.idMjereOsobe)
                    }
                    disabled={mjera.nazivDok3 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena3 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena3}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
                  <td>
                    {mjera.datBrisanja ? mjera.datBrisanja : noDataMessage}
                  </td>
                ) : null}
              </tr>
            ))
          ) : (
            <tr key={`mjere`}>
              <td colSpan="8"></td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default OvlasteniRevizoriDrugihDrzavaDetaljiTable;
